import React from 'react';
import { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { MobileNavBar, NavBar } from '../components/NavBar';
import DrumMenu from '../components/HomeNavBar';

import { Orientation, useDeviceOrientation } from '../hooks/device-orientation';

import logo from '../assets/img/logo.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Home.scss';

const conf = require('../config/web-site');
const minWidthForDesktopMenu = 992;

type HomeProps = {
  scroller: (arg: string) => void;
}

const Home: React.FC<HomeProps> = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [burst, setBurst] = useState(false);

  const handleLogoBurst = () => {
    setBurst(true);
    setTimeout(() => setBurst(false), 800);
  };

  const { scroller } = props;
  const orientation = useDeviceOrientation();

  return (
    <section id='home' data-testid='home-view'>
      <section className='nav-main'>
      { orientation === Orientation.Portrait || width < minWidthForDesktopMenu
        ? <MobileNavBar {...{ scroller }} />
        : <NavBar {...{ scroller }} />
      }
      </section>
      <Container fluid>
      <Row>
        <Col>
          <img
            src={logo}
            alt={conf.title}
            className={`logo${burst ? ' logo-burst' : ''}`}
            onClick={handleLogoBurst}
            style={{ cursor: 'pointer' }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DrumMenu />
        </Col>
      </Row>
      </Container>
      <div className='scroll-cue' aria-hidden='true' />
    </section>
  );
}

export default Home;